import { render, staticRenderFns } from "./default-no-bg.vue?vue&type=template&id=476146a0"
import script from "./default-no-bg.vue?vue&type=script&lang=js"
export * from "./default-no-bg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutCookieConsent: require('/builds/athlyzer-devs/athlyzer-website/components/layout/cookie-consent.vue').default,LayoutLocaleSwitcher: require('/builds/athlyzer-devs/athlyzer-website/components/layout/locale-switcher.vue').default,LayoutHeader: require('/builds/athlyzer-devs/athlyzer-website/components/layout/header.vue').default,LayoutFooter: require('/builds/athlyzer-devs/athlyzer-website/components/layout/footer.vue').default})
